import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateRangeValidator(minDate: Date, maxDate: Date): ValidatorFn {
  return (control: FormControl): ValidationErrors | null => {
    const currentDateString: string = control.value;
    const currentDate = new Date(currentDateString);

    if (
      (minDate && currentDate.getTime() < minDate.getTime()) ||
      (maxDate && currentDate.getTime() > maxDate.getTime())
    ) {
      return {
        dateOutOfRange: true,
      };
    }

    return null;
  };
}
